// Mutation names of the operations to create an account
export const ACCOUNT_CREATION_OPERATIONS = {
  APPROVE_GUEST_PAYMENT_APPLE_PAY:
    'ApproveGuestPaymentWithApplePayTokenMutation',
  CREATE_MEMBER_ACCOUNT: 'CreateMemberAccountMutation',
  ONBOARD_GUEST: 'OnboardGuestMutation',
  SIGN_UP_NEW_MEMBER: 'SignUpNewMemberMutation',
};

export const OPERATION_NAME_TO_RESPONSE_KEY_MAP = {
  OnboardGuestMutation: 'onboardAccount',
  SignUpNewMemberMutation: 'onboardAccount',
};

// Map of account creation operation names to the access token type
export const OPERATION_TO_ACCESS_TOKEN_MAP = {
  ApproveGuestPaymentWithApplePayTokenMutation: 'guest',
  CreateMemberAccountMutation: 'signup',
  OnboardGuestMutation: 'guest',
  SignUpNewMemberMutation: 'signup',
};
